module.exports = __webpack_public_path__ + "static/img/logo.1e93ca7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 47